import styled, { css } from 'styled-components';

// DeltaPill — apenas texto colorido (sem fundo). O background pill atras
// do "+1,1%" / "sem base" / "0%" foi removido a pedido — ficava como
// chip sobreposto na celula bordered da PeriodRow, poluindo o visual.
// So a cor da variant (good=green, bad=red, neutral=mute) diferencia.
const variants = {
  good: css`
    color: var(--cco-green);
  `,
  bad: css`
    color: var(--cco-red);
  `,
  neutral: css`
    color: var(--cco-ink-mute);
  `,
};

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  background: transparent;
  font-size: ${(props) => (props.small ? '10px' : '11px')};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
  white-space: nowrap;
  ${(props) => variants[props.variant || 'neutral']}
`;

export const Arrow = styled.span`
  font-size: 0.85em;
  line-height: 1;
`;
